import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatUsd(amount: number): string {
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(amount);
}

export function formatCdf(amount: number): string {
  return new Intl.NumberFormat("fr-CD", { maximumFractionDigits: 0 }).format(amount) + " FC";
}

/** Returns inline dual-currency string: "$12.50 (≈ 35 000 CDF)" */
export function formatMoney(usd: number, rate: number): string {
  const cdf = Math.round(usd * rate);
  return `${formatUsd(usd)} (≈ ${cdf.toLocaleString("fr-FR")} CDF)`;
}

/** Returns only the CDF sub-label: "≈ 35 000 CDF" */
export function formatMoneyCdf(usd: number, rate: number): string {
  const cdf = Math.round(usd * rate);
  return `≈ ${cdf.toLocaleString("fr-FR")} CDF`;
}

export function formatPercent(value: number): string {
  return `${value.toFixed(1)}%`;
}
